import Crud from '../components/WorkstationsDetails/Crud'
import Entity from '../components/WorkstationsDetails/Add'

let routes = {
    path: '/workstation_details',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/workstation_details/add',
            name: 'Novo Adicional',
            component: Entity
        },
        {
            path: '/workstation_details/edit/:id?',
            name: 'Editar Adicional',
            component: Entity
        },
        {
            path: '/workstation_details',
            name: 'Adicionais da Sala',
            component: Crud
        },
    ]
};

export default routes


// WEBPACK FOOTER //
// ./src/router/workstation_details.js